export const fontPrimary = "'Lato', sans-serif;"
export const fontSecondary = "'Noto Serif JP', sans-serif;"
export const colorPrimary = '#1bbfc7'
export const colorPrimaryRGBA = opacity => `rgba(27, 191, 199, ${opacity})`
export const colorBlack = '#2c2d32'
export const colorWhite = '#fff'
